/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 17:42:36
 * @FilePath: \mrc-ess-fronted\src\util\components.js
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-03 10:18:43
 */
import Vue from "vue";
//错误警告弹窗
import VueConfirm from "@/components/confirm/index.js";
//转pdf
import htmlToPdf from "@/util/htmlToPdf.js";
//其他组件
import ContentNav from "@/components/MRC_ESS_ContentNav";
import ContentLayout from "@/Layout/components/ContentLayout";
import normalDialog from "@/components/MRC_ESS_normalDialog";
import Taber from "@/components/MRC_ESS_Taber";
import Stepper from "@/components/MRC_ESS_Stepper";
import Tabler from "@/components/MRC_ESS_Tabler";
import Pagenations from "@/components/MRC_ESS_Pagenations";
import noContent from "@/components/MRC_ESS_noContent";
import tableListTools from "@/components/MRC_ESS_tableListTools";
import TimePicker from "@/components/MRC_ESS_TimePicker";
import SpecialTable from "@/components/MRC_ESS_SpecialTable";
import CardActions from "@/components/MRC_ESS_CardActions";
import inputTextFiled_multiLang from "@/components/MRC_ESS_inputTextFiled_multiLang";
import PropertyList from "@/components/MRC_ESS_PropertyList";
import TimeLine from "@/components/MRC_ESS_TimeLine";
import ImgDragUpdate from "@/components/MRC_ESS_ImgDragUpdate";
import FileDragUpdate from "@/components/MRC_ESS_FileDragUpdate";
import Microsoft_FileDragUpdate from "@/components/MRC_ESS_Microsoft_FileDragUpdate";
import LightBox from "@/components/MRC_ESS_LightBox";
import DateTimePicker from "@/components/MRC_ESS_DateTimePicker";
import TimePickerSheet from "@/components/MRC_ESS_TimePickerSheet.vue";
import normalInputTextFiled from "@/components/MRC_ESS_normalInputTextFiled";
import numberInputTextFiled from "@/components/MRC_ESS_numberInputTextFiled";
import StaffAvatar from "@/components/MRC_ESS_StaffAvatar";
import SelectColor from "@/components/MRC_ESS_selectColor";
import SelectDepartments from "@/components/MRC_ESS_selectDepartments";
import Selections from "@/components/MRC_ESS_List_Selections_backup/Top_Selection";
import Selections2 from "@/components/MRC_ESS_List_Selections/Top_Selection";
import FilterInputField from "@/components/MRC_ESS_List_Selections/Filter_Input_Fields";
import Print from "@/util/print";
import Announcement from "@/Layout/components/Announcement";
import CardLine from "@/components/MRC_ESS_Card_Line.vue";
import DynamicForm from "@/components/MRC_ESS_DynamicForm.vue";
import BooleanRadioField from "@/components/MRC_ESS_BooleanField.vue";
import Section from "@/components/MRC_ESS_Form_Sections.vue";
import ApprovalTriger from "@/components/MRC_ESS_Form_ApprovalTriger.vue";
import StatusChip from "@/components/MRC_ESS_List_Chip_Status.vue";
import AutoComplete from "@/components/MRC_ESS_Form_AutoComplete.vue";
Vue.use(VueConfirm); //弹窗
Vue.use(htmlToPdf); //转换pdf
Vue.use(Print); // 打印
Vue.component("ContentNav", ContentNav); //组件初始化
Vue.component("ContentLayout", ContentLayout); //组件初始化
Vue.component("normalDialog", normalDialog); //组件初始化
Vue.component("Taber", Taber); //组件初始化
Vue.component("Stepper", Stepper); //组件初始化
Vue.component("Tabler", Tabler); //组件初始化
Vue.component("Pagenations", Pagenations); //组件初始化
Vue.component("noContent", noContent); //组件初始化
Vue.component("tableListTools", tableListTools); //组件初始化
Vue.component("TimePicker", TimePicker); //组件初始化
Vue.component("SpecialTable", SpecialTable); //组件初始化
Vue.component("CardActions", CardActions); //组件初始化
Vue.component("inputTextFiledMultiLang", inputTextFiled_multiLang); //组件初始化
Vue.component("PropertyList", PropertyList); //组件初始化
Vue.component("TimeLine", TimeLine); //组件初始化
Vue.component("ImgDragUpdate", ImgDragUpdate); //组件初始化
Vue.component("FileDragUpdate", FileDragUpdate); //组件初始化
Vue.component("MicrosoftFileDragUpdate", Microsoft_FileDragUpdate); //组件初始化
Vue.component("LightBox", LightBox); //组件初始化
Vue.component("DateTimePicker", DateTimePicker); //组件初始化
Vue.component("TimePickerSheet", TimePickerSheet); //组件初始化
Vue.component("normalInputTextFiled", normalInputTextFiled); //组件初始化
Vue.component("numberInputTextFiled", numberInputTextFiled); //组件初始化
Vue.component("StaffAvatar", StaffAvatar); //组件初始化
Vue.component("SelectColor", SelectColor); //组件初始化
Vue.component("Selections", Selections); //组件初始化
Vue.component("Selections2", Selections2); //组件初始化
Vue.component("FilterInputField", FilterInputField); //组件初始化
Vue.component("Announcement", Announcement); //组件初始化
Vue.component("CardLine", CardLine); //组件初始化
Vue.component("DynamicForm", DynamicForm); //组件初始化
Vue.component("BooleanRadioField", BooleanRadioField); //组件初始化
Vue.component("Section", Section); //组件初始化
Vue.component("ApprovalTriger", ApprovalTriger); //组件初始化
Vue.component("StatusChip", StatusChip); //组件初始化
Vue.component("AutoComplete", AutoComplete); //组件初始化
Vue.component("SelectDepartments", SelectDepartments); //组件初始化
